// All comments in English.
import { http } from "@/core/http";

/** Shape aligned with OpenAPI ProductOption. */
export interface ProductItem {
  product: string;
  seat_band_thresholds: Record<string, unknown>;
}

export interface ProductSearchParams {
  /** Local filter keyword (client-side). */
  q?: string;
  /** Local limit (client-side). */
  limit?: number;
  /** Whether to request seat band thresholds from backend. */
  includeSeatBands?: boolean;
}

/** Accept both new shape ({ items: [...] }) and legacy array shape. */
type ProductsApiResponse = { items: ProductItem[] } | ProductItem[];

/**
 * Fetch products from backend and apply client-side filter/slice.
 * Backend endpoint: GET /autodesk_usage/meta/products?includeSeatBands=true|false
 */
export async function getProducts(params: ProductSearchParams = {}) {
  const {
    q = "",
    limit = 20,
    includeSeatBands = true,
  } = params;

  // Call the endpoint and support both {items: []} and [] response shapes.
  const { data } = await http.get<ProductsApiResponse>(
    "/autodesk_usage/meta/products",
    { params: { includeSeatBands } }
  );

  // Normalize response to a flat array.
  const items: ProductItem[] = Array.isArray(data) ? data : (data?.items ?? []);

  // Apply client-side filtering and limiting to preserve old signature.
  const keyword = q.trim().toLowerCase();
  const filtered = keyword
    ? items.filter((p) => p.product.toLowerCase().includes(keyword))
    : items;

  return filtered.slice(0, limit);
}
